import request from '@/utils/request'

export const getSimpleList = () => {
  return request({
    method: 'GET',
    url: '/cms/suppliers/simple_list'
  })
}

export const getSupplierMap = () => {
  return request({
    method: 'GET',
    url: '/cms/suppliers/supplier_map'
  })
}

export const getSuppliersSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/suppliers/setup'
  })
}

export const getSuppliers = (params) => {
  return request({
    method: 'GET',
    url: '/cms/suppliers',
    params
  })
}

export const getSuppliersEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/suppliers/${id}/preview`
  })
}

export const getSuppliersDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/suppliers/${id}`
  })
}

export const suppliersEdit = (data, id) => {
  return request({
    method: 'PUT',
    url: `/cms/suppliers/${id}`,
    data
  })
}

export const suppliersAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/suppliers',
    data
  })
}

export const deleteOnlineCouponDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/suppliers/${id}`
  })
}

// 导入
export const insertExcel = (data) => {
  return request({
    method: 'post',
    url: '/cms/suppliers/import',
    data
  })
}

// 采购单
export const getPurchaseOrdersSetup = (params) => {
  return request({
    method: 'GET',
    url: '/cms/purchase_orders/setup',
    params
  })
}

export const getPurchaseOrders = (params) => {
  return request({
    method: 'GET',
    url: '/cms/purchase_orders',
    params
  })
}

export const getPurchaseOrdersEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/purchase_orders/${id}/preview`
  })
}

export const getPurchaseOrdersDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/purchase_orders/${id}`
  })
}

export const purchaseOrdersEdit = (data, id) => {
  return request({
    method: 'PUT',
    url: `/cms/purchase_orders/${id}`,
    data
  })
}

export const purchaseOrdersAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/purchase_orders',
    data
  })
}

export const getShopItemStocksByItemIdSimpleList = (id, params) => {
  return request({
    method: 'GET',
    url: `/cms/shop_items/${id}/shop_item_stocks/simple_list`,
    params
  })
}

export const getShopItemsSimpleList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/shop_items/simple_list',
    params
  })
}

export const getPurchaseOrdersSimpleList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/purchase_orders/simple_list',
    params
  })
}

export const deletePurchaseDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/purchase_orders/${id}`
  })
}

// 采购单导出
export const getPurchaseExcel = (params) => {
  return request({
    method: 'get',
    url: '/cms/purchase_orders/export',
    params
  })
}
// 采购单结束

// 退货单
export const getReturnOrdersSetup = (params) => {
  return request({
    method: 'GET',
    url: '/cms/return_orders/setup',
    params
  })
}

export const getReturnOrders = (params) => {
  return request({
    method: 'GET',
    url: '/cms/return_orders',
    params
  })
}

export const getReturnOrdersEditDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/return_orders/${id}/preview`
  })
}

export const getReturnOrdersDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/return_orders/${id}`
  })
}

export const returnOrdersEdit = (data, id) => {
  return request({
    method: 'PUT',
    url: `/cms/return_orders/${id}`,
    data
  })
}

export const getInvoiceExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/purchase_orders/invoice_export',
    data
  })
}

export const getInvoiceListingExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/purchase_orders/invoice_listing_export',
    data
  })
}

export const returnOrdersAdd = (data) => {
  return request({
    method: 'POST',
    url: '/cms/return_orders',
    data
  })
}

export const deleteReturnOrdersDetails = (id) => {
  return request({
    method: 'DELETE',
    url: `/cms/return_orders/${id}`
  })
}
// 退货单结束
